/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TreeItemController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class TreeItemController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class TreeItemController extends cls.ControllerBase /** @lends classes.TreeItemController.prototype */ {
    static __name = "TreeItemController";

    _initBehaviors() {
      super._initBehaviors();

      // 4st behaviors

      // vm behaviors
      this._addBehavior(cls.TreeItemDecorationVMBehavior);
    }

    /**
     * TreeItems don't create their own widgets, they simply act on the corresponding table column
     */
    createWidget() {
      return null;
    }
  }

  cls.TreeItemController = TreeItemController;
  cls.ControllerFactory.register("TreeItem", cls.TreeItemController);
});
